<template>
  <a-dialog
    v-model="showSignerSelectDialog"
    scrollable
    max-width="800px"
    persistent
  >
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span>{{ $t("chat.lblNewChatCreation") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="showSignerSelectDialog = false" />
        </v-toolbar>
      </v-banner>

      <v-card-text>
        <v-container style="padding: 0 !important">
          <v-card
            class="d-flex justify-end mb-6"
            flat
            tile
          >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mx-1 my-1"
                color="primaryDark"
                v-bind="attrs"
                v-on="on"
                size=""
                @click="addAll"
              >
              {{ $t("chat.lblAddAllAttendees") }}
              </a-btn>
            </template>
            <span>{{ $t("chat.toolTipAddAllAttendees") }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mx-1 my-1"
                color="primaryDark"
                v-bind="attrs"
                v-on="on"
                size=""
                @click="clearAll"
              >
              {{ $t("lblClear") }}
              </a-btn>
            </template>
            <span>{{ $t("lblClear") }}</span>
          </v-tooltip>
          </v-card>
          <v-row>
            <v-col cols="12">
              <meeting-participants
                :meetingAtteendeelist.sync="singerList"
                @onSelection="onParticipantSelection"
                :label="$t('chat.lblParticipant')"
                :suggestedList="attendeeSuggestionList"
                type="signer"
                :adHocEmail="false"
                :key="componentKey"
              ></meeting-participants>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              color="primaryDark"
              class="mr-2"
              @click="selectParticipant"
              :disabled="newParticipantList.length === 1 || isDirty"
            >
              {{ $t("btnAdd") }}
            </a-btn>
          </template>
          <span> {{ $t("chat.lblAddParticipant") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              color="secondary"
              @click="showSignerSelectDialog = false"
            >
              {{ $t("widget.close") }}
            </a-btn>
          </template>
          <span> {{ $t("widget.close") }} </span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import MeetingParticipants from "../MeetingParticipants.vue";
import { mapState } from "vuex";
import _ from "lodash";
import { createUUID } from "../../../utils/util";

export default {
  name: "ChatParticipant",
  components: { MeetingParticipants },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    chatData: {
      type: Object,
      default: () => {},
    },
    participantList: Array,
    attendeesList: Array,
  },
  data() {
    return {
      btnAssignDisable: true,
      newParticipantList: [],
      meetingAtteendeelist: [],
      componentKey: createUUID()
    };
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
      chatParticipants: (state) => state.agenda.agendaMeetingChatParticipants,
    }),
    showSignerSelectDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    singerList: {
      get() {
        const loggedUserId = (this.chatData && this.chatData.created_by) ? this.chatData.created_by : this.$auth.user.user_id;
        const userData = _.cloneDeep(this.meetingAtteendeelist);
        const loggedUserIndex = userData.findIndex(
          (elem) => elem.id === loggedUserId
        );

        if (loggedUserIndex === -1) {
          const findUser = this.chatParticipants.find(
            (user) => user.id === loggedUserId
          );

          if (findUser) {
            findUser.disabled = true;
            findUser.email = findUser.registered_email;
            userData.push(findUser);
          }
        }else {
          userData[loggedUserIndex].disabled = true;
        }

        return userData;
      },
      set(value) {
        this.meetingAtteendeelist = value;
      },
    },
    isDirty() {

      const sortEmails = list => list.map(obj => obj.email).sort();

      const participantListEmails = sortEmails(this.participantList);
      const newParticipantListEmails = sortEmails(this.newParticipantList);
      return (
        JSON.stringify(participantListEmails) == JSON.stringify(newParticipantListEmails)
      );
    },
    attendeeSuggestionList() {
      const loggedUserId = (this.chatData && this.chatData.created_by) ? this.chatData.created_by : this.$auth.user.user_id;
      return this.chatParticipants.filter(attendee => attendee.id !== loggedUserId);
    },
  },
  mounted() {
    this.meetingAtteendeelist = this.participantList;
  },
  methods: {
    onParticipantSelection,
    selectParticipant,
    addAll(){
      this.componentKey = createUUID()
      const filteredAttendees = this.attendeesList.filter(attendee =>
        this.chatParticipants.some(user => user.id === attendee.id)
      );
      this.singerList = filteredAttendees
    },
    clearAll(){
      this.componentKey = createUUID()
      this.singerList = []
    }
  },
};

function selectParticipant() {
  // Helper function to set default properties
  const setDefaultProperties = (obj) => ({
    ...obj,
    isOwner: obj.isOwner || "required",
    order: obj.order || null,
  });

  // Set default properties and map to a new array
  const list = this.newParticipantList.map(setDefaultProperties);

  // Filter objects with order property
  const objectsWithOrder = list.filter((obj) => obj.order !== null);

  // Find the maximum order value
  const maxOrder = objectsWithOrder.reduce(
    (max, obj) => Math.max(max, obj.order),
    0
  );

  // Assign new order values to objects without order property
  let newOrder = maxOrder + 1;
  const newArray = list.map((obj) => ({
    ...obj,
    order: obj.order === null ? newOrder++ : obj.order,
  }));

  // Emit events
  this.$emit(
    "update:participantList",
    newArray.sort((a, b) => a.order - b.order)
  );
  this.$emit("input", false);
}

function onParticipantSelection(signer) {
  // Helper function to extract and format signer data
  const extractSigner = (list) =>
    (list || [])
      .map(({ id, email, emailList = [] }) => ({ id, email, emailList }))
      .sort((a, b) => a.email.localeCompare(b.email));

  // Extract and format original and selected signers
  const originalMeetingSigner = extractSigner(this.participantList);
  const assignSigner = extractSigner(signer);

  // Set btnAssignDisable based on equality of original and selected signers
  this.btnAssignDisable =
    JSON.stringify(originalMeetingSigner) === JSON.stringify(assignSigner);

  // Merge signer data and set to newParticipantList
  this.newParticipantList = signer.map((obj2) => {
    const matchingObj = this.participantList.find(
      (obj1) => obj1.email === obj2.email
    );

    // Merge properties if matching object exists, otherwise add default properties
    return matchingObj
      ? { ...obj2, ...matchingObj }
      : {
          ...obj2,
          order: null,
        };
  });
}

</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>